import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import moment from 'moment';
import i18n from 'i18next';
import { DOMESTIC } from '../../../constants/variables';
import InfoTooltip from '../../common/tooltip/info/index';
import AbroadDetail from '../../abroad/detail/index';
import DomesticDetail from '../../domestic/detail/index';
import TravelDateDetail from './date';
import IndividualAccommodationDetail from './individual-accommodation';
import CalculatedAmountDetail from './amount';
import ManagerApprove from './manager-approve';
import RevisionModal from '../revision';
import RejectComponents from '../../actions/reject/component';
import InputModal from '../../common/modal/input';
import InfoRejectButton from '../../actions/reject/info';
import PDFDownload from '../pdf/index';
import {
  ACCOUNTING,
  COMPLETED,
} from '../../../constants/travelExpenseStatus';

class RequestDetailModal extends React.Component {
  constructor(props) {
    super(props);

    this.handle = this.handle.bind(this);
    this.state = { showModal: false, showRevisionModal: false };
  }

  handle() {
    this.setState({ showModal: !this.state.showModal, showRevisionModal: false });
  }

  render() {
    const { request, isManager, t } = this.props;
    let paymentType;

    if (request.harcirahPaymentItems === undefined){
      paymentType = {
        yd: 'Net',
        yi: 'Brut',
        ybk: 'Net',
        ydbk: 'Net'
      };

    } else {
      paymentType = request.harcirahPaymentItems;

    }


    // eslint-disable-next-line no-unreachable
    return (
      <div style={{ display: 'inline' }}>
        <InfoTooltip info={i18n.t('travelExpenseDetail')} className="TalepDetayi">
          <button className="btn btn-xs btn-info btn-fill " onClick={this.handle}>
            <i className="fa fa-info" />
          </button>
        </InfoTooltip>
        <Modal show={this.state.showModal} onHide={this.handle}>
          <Modal.Header closeButton>
            <Modal.Title>
              {i18n.t('requestDetail')}
              <span>
                <small className="margin-left" id="costCreatedDate">
                  {moment(new Date(request.createdDate))
                    .format('DD-MM-YYYY HH:mm')}
                </small>
              </span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <TravelDateDetail request={request} isManager={isManager} />
            {request.type === DOMESTIC
              ? <DomesticDetail request={request} />
              : <AbroadDetail request={request} /> }
            {request.description ? (
              <div className="well well-sm" id="costDetailDescription">
                <b>
                  {i18n.t('explanation')}
                  :
                </b>
                <br />
                {request.description}
              </div>
            ) : null}
            <IndividualAccommodationDetail request={request} />
            {
                  request.confirmationDate
                    ? (
                      <ManagerApprove
                        request={request}
                      />
                    ) : null
              }
            {
                            (request.calculatedAmount)
                              ? <CalculatedAmountDetail request={request} isManager={isManager} paymentType={paymentType} />
                              : null
                        }
          </Modal.Body>
          <Modal.Footer>
            <div className="text-center">
              <Button
                id="costDetailRevisionsButton"
                className="btn btn-warning btn-fill btn-wd pull-left"
                onClick={() => {
                  this.setState({ showModal: false, showRevisionModal: true });
                }}
              >
                {i18n.t('revisions')}
              </Button>
              { this.props.approve ? (
                <button
                  id="costDetailApprovalButton"
                  className="btn btn-success pull-left"
                  onClick={this.props.approve}
                >
                  <i
                    className="fa fa-check"
                  />
                  {i18n.t('approve')}
                </button>
              ) : null}

              {request.status === ACCOUNTING || request.status === COMPLETED
                ? <PDFDownload request={request} isDetailedPdf />
                : null

            }
              { this.props.reject ? (

                <InputModal
                  title="Harcırah reddedilecek"
                  trigger={InfoRejectButton}
                  triggerInfo={this.props.waitingForCancelled}
                  submit={this.props.reject}
                  submitLabel="Onayla"
                  Component={RejectComponents}
                  ComponentProps={{ harcirahId: request._id }}
                />

              ) : null}
              <Button id="costDetailCloseButton" className="pull-right" onClick={this.handle}>
                {i18n.t('close')}
              </Button>

            </div>
          </Modal.Footer>

        </Modal>
        <RevisionModal request={request} showRevisionModal={this.state.showRevisionModal} onChange={this.handle} />
      </div>
    );
  }
}

export default RequestDetailModal;



// WEBPACK FOOTER //
// ./src/components/travel-expense/detail/index.js